import React from "react";
import {
  Card,
  CardActionArea,
  Grid,
  Container,
  Typography,
  Paper,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomAppBar from "../../components/AppBar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { ShoppingCart, Assignment, Agriculture } from "@mui/icons-material";

const useStyles = makeStyles(() => ({
  cardTitle: {
    fontSize: "25px !important",
    fontStyle: "Poppins  !important",
    lineHeight: "37.5px  !important",
    marginTop: "10px !important",
  },
  title: {
    textAlign: "center",
    padding: "20px 0",
    borderRadius: "4px",
    marginBottom: "20px",
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
}));
export default function BiocharLandingScreen() {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const buttons = [
    {
      label: t("Request Biochar"),
      icon: ShoppingCart,
      route: "/request-biochar",
      color: "#00BCD4",
    },
    {
      label: t("Biochar Orders"),
      icon: Assignment,
      route: "/biochar-orders",
      color: " #FFEB3B ",
    },
    {
      label: t("Biomass Procurement"),
      icon: Agriculture,
      route: "/procurement-list",
      color: "#FF5722",
    },
  ];

  return (
    <div>
      <CustomAppBar />

      <Container maxWidth="xs" style={{ marginTop: 20 }}>
        <Paper className={classes.title} elevation={0}>
          <Typography variant="h5">{t("Biochar")}</Typography>
        </Paper>
        <Grid container spacing={2}>
          {buttons.map((button, index) => (
            <Grid
              item
              xs={12}
              key={index}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Card
                variant="outlined"
                style={{
                  width: "100%",
                  height: 162,
                  backgroundColor: `${button.color}`,
                }}
              >
                <CardActionArea
                  onClick={() => navigate(button.route)}
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button.icon sx={{ fontSize: 60, color: "#000000" }} />
                  <div>
                    <Typography className={classes.cardTitle}>
                      {button.label}
                    </Typography>
                  </div>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
